<div id="banner-funds-remunerada" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-12 col-lg-8">
        <div class="img-container mb-3">
          <img src="/assets/images/funds/myInvestor/FUNDS+MYI.svg" alt="MyInvestor | SEGO Funds" title="MyInvestor | SEGO Funds" class="img-fluid logo-myinvestor">
        </div>
        @if (cuentaRemuneradaData) {
        <h1 class="primary-900 h1-display mb-2">¡<span class="secondary-funds-700">{{cuentaRemuneradaData.tae | decimalFormat: 'two-decimals'}}% TAE</span> en tu <br class="d-block d-xxl-none">
          cuenta corriente!</h1>
        <div class="d-none d-lg-block">
          <p class="p-display">
            Por formar parte de SEGOFINANCE tendrás condiciones exclusivas en tu cuenta de MyInvestor.
          </p>
        </div>
        <div class="mt-3 mt-lg-4">
          <app-btn-link [linkId]="'btn-banner-cta-remunerada'" [linkTitle]="'Más información'" [linkUrl]="'/cuentas-remuneradas'"></app-btn-link>
        </div>
        }
      </div>
      <div class="col-12 col-lg-4 contenedor-remunerada text-center mt-2 mt-lg-0">
        <img [src]="animatedBackground[currentImageIndex]" alt="SEGO Funds: Cuenta remunerada" class="img-fluid">
      </div>
    </div>
  </div>
</div>